"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const round_1 = __importDefault(require("lodash/round"));
const constants_1 = require("../../lib/constants");
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const star_rating_1 = __importDefault(require("./star-rating"));
const SubRatings = ({ subRatings, intl }) => {
    const mappedSubRatings = subRatings.map(({ metric, average_rating }) => {
        const roundedSubRating = (0, round_1.default)(average_rating, 1);
        return (react_1.default.createElement(styles_1.SubRatingRow, { key: metric, "aria-label": intl.formatMessage(messages_1.default.ariaMetricStarRatingsAverage, {
                metric: metric,
                rating: roundedSubRating
            }) },
            react_1.default.createElement(styles_1.RatingTitle, null, metric),
            react_1.default.createElement(styles_1.RatingStarValue, null,
                react_1.default.createElement(star_rating_1.default, { rating: roundedSubRating, starSize: constants_1.RATINGS_AND_REVIEWS.SUBCATEGORY_STAR_SIZE, widthAccuracyCorrection: constants_1.RATINGS_AND_REVIEWS.SUBCATEGORY_STARS_ACCURACY_CORRECTION_WIDTH }),
                react_1.default.createElement(styles_1.AvgMetricsReviewRatings, null,
                    react_1.default.createElement("span", { "aria-hidden": true }, roundedSubRating)))));
    });
    return react_1.default.createElement(styles_1.SubRatingsContainer, null, mappedSubRatings);
};
exports.default = (0, intl_1.injectIntl)(SubRatings);
//# sourceMappingURL=sub-ratings.js.map